import Vue from 'vue'
import {
  getJobByIdQuery,
  getJobItemsByJobIdQuery,
  getJobsByRelatedQuery,
  getJobsByTypeQuery,
  getJobsByStatusQuery,
  createJobMutation,
  createJobItemMutation,
  updateJobMutation,
  updateJobItemMutation,
  deleteJobMutation,
  deleteJobItemMutation
} from '~graphql/jobs.graphql'

export default {
  getJobById({ state, dispatch }, id) {
    return dispatch('getItem', {
      state,
      loader: 'job:get',
      modelName: 'selectedJob',
      query: getJobByIdQuery,
      resultPath: 'job',
      variables: {
        id
      }
    })
  },
  getJobItemsByJobId({ state, dispatch }, jobId) {
    return dispatch('getItems', {
      state,
      loader: 'jobItems:get',
      modelName: 'jobItems',
      query: getJobItemsByJobIdQuery,
      resultPath: 'jobItems.nodes',
      variables: {
        jobId
      }
    })
  },
  getJobsByRelated({ state, dispatch }, { relatedId, relatedTable }) {
    return dispatch('getItems', {
      state,
      loader: 'jobs:get',
      modelName: 'jobs',
      query: getJobsByRelatedQuery,
      resultPath: 'jobs.nodes',
      variables: {
        relatedId,
        relatedTable
      }
    })
  },
  getJobsByType({ state, dispatch }, type) {
    return dispatch('getItems', {
      state,
      loader: 'jobs:get',
      modelName: 'jobs',
      query: getJobsByTypeQuery,
      resultPath: 'jobs.nodes',
      variables: {
        type
      }
    })
  },
  getJobsByStatus({ state, dispatch }, status) {
    return dispatch('getItems', {
      state,
      loader: 'jobs:get',
      modelName: 'jobs',
      query: getJobsByStatusQuery,
      resultPath: 'jobs.nodes',
      variables: {
        status
      }
    })
  },
  createJob({ state, dispatch }, job) {
    return dispatch('createItem', {
      item: { job },
      state,
      modelName: 'jobs',
      loader: 'job:create',
      mutation: createJobMutation,
      resultPath: 'createJob.job'
    })
  },
  createJobs({ state, dispatch }, jobs) {
    const totalRows = jobs.length
    Vue.loadingDialog({ text: 'Criando jobs', step: 0, numSteps: totalRows })

    const progress = ({ remainingItems }) => {
      const step = totalRows - remainingItems
      Vue.loadingDialog({ text: `Criando jobs ${step} de ${totalRows}`, step, numSteps: totalRows })
    }

    const finish = () => {
      Vue.toasted.success('Jobs criados com sucesso!')
      Vue.closeLoadingDialog()
      Vue.bus.$off('job-create:progress', progress)
      Vue.bus.$off('job-create:finished', finish)
    }

    Vue.bus.$on('job-create:progress', progress)
    Vue.bus.$on('job-create:finished', finish)

    return dispatch('createItems', {
      items: jobs,
      state,
      loader: 'job-create',
      mutation: createJobMutation,
      resultPath: 'createJob.job',
      progressEvent: 'job-create:progress'
    })
  },
  updateJobs({ state, dispatch }, jobs) {
    const totalRows = jobs.length
    Vue.loadingDialog({ text: 'Atualizando jobs', step: 0, numSteps: totalRows })

    const progress = ({ remainingItems }) => {
      const step = totalRows - remainingItems
      Vue.loadingDialog({ text: `Atualizando jobs ${step} de ${totalRows}`, step, numSteps: totalRows })
    }

    const finish = () => {
      Vue.toasted.success('Jobs atualizados com sucesso!')
      Vue.closeLoadingDialog()
      Vue.bus.$off('job-update:progress', progress)
      Vue.bus.$off('job-update:finished', finish)
    }

    Vue.bus.$on('job-update:progress', progress)
    Vue.bus.$on('job-update:finished', finish)

    return dispatch('updateItems', {
      items: jobs,
      state,
      loader: 'job-update',
      mutation: updateJobMutation,
      resultPath: 'updateJob.job',
      progressEvent: 'job-update:progress'
    })
  },
  createJobItem({ state, dispatch }, jobItem) {
    return dispatch('createItem', {
      item: { jobItem },
      state,
      modelName: 'jobItems',
      loader: 'jobItem:create',
      mutation: createJobItemMutation,
      resultPath: 'createJobItem.jobItem'
    })
  },
  createJobItems({ state, dispatch }, jobItems) {
    const totalRows = jobItems.length
    Vue.loadingDialog({ text: 'Criando job items', step: 0, numSteps: totalRows })

    const progress = ({ remainingItems }) => {
      const step = totalRows - remainingItems
      Vue.loadingDialog({ text: `Criando job items ${step} de ${totalRows}`, step, numSteps: totalRows })
    }

    const finish = () => {
      Vue.toasted.success('Job items criados com sucesso!')
      Vue.closeLoadingDialog()
      Vue.bus.$off('jobItem-create:progress', progress)
      Vue.bus.$off('jobItem-create:finished', finish)
    }

    Vue.bus.$on('jobItem-create:progress', progress)
    Vue.bus.$on('jobItem-create:finished', finish)

    return dispatch('createItems', {
      items: jobItems,
      state,
      loader: 'jobItem-create',
      mutation: createJobItemMutation,
      resultPath: 'createJobItem.jobItem',
      progressEvent: 'jobItem-create:progress'
    })
  },
  updateJobItem({ state, dispatch }, jobItem) {
    return dispatch('updateItem', {
      item: jobItem,
      state,
      modelName: 'selectedJobItem',
      loader: 'jobItem:update',
      mutation: updateJobItemMutation,
      resultPath: 'updateJobItem.jobItem'
    })
  },
  deleteJob({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'jobs',
      loader: 'job:delete',
      mutation: deleteJobMutation,
      resultPath: 'deleteJob.job'
    })
  },
  deleteJobItem({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'jobItems',
      loader: 'jobItem:delete',
      mutation: deleteJobItemMutation,
      resultPath: 'deleteJobItem.jobItem'
    })
  },
  updateJob({ state, dispatch }, job) {
    return dispatch('updateItem', {
      item: job,
      state,
      modelName: 'selectedJob',
      loader: 'job:update',
      mutation: updateJobMutation,
      resultPath: 'updateJob.job'
    })
  }
}
